import { MultipleQuestion } from '@/models/commons/form'

/** Method to check if some question is SingleQuestion or MultipleQuestion */
export const isMultipleQuestion = (object: any): object is MultipleQuestion => {
  return object && 'manyQuestions' in object
}
